import { AfterViewInit, Component, ElementRef, computed, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { dsDtos, dsEnums } from '@vectronic/openApi-admin';
import { ParameterDataService } from '@vectronic/util';
import { ParameterViewComponent } from '../../parameters/parameter-view/parameter-view.component';
import { DIALOG_WIDE_CONFIG } from '../../utils/configs/dialog.config';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'vectronic-parameter-dialog',
  templateUrl: './parameter-dialog.component.html',
  styleUrls: ['./parameter-dialog.component.scss'],
  imports: [
    CardComponent,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatButtonToggleModule,
    ParameterViewComponent,
  ],
})
export class ParameterDialogComponent implements AfterViewInit {
  parameterDataService = inject(ParameterDataService);

  private readonly hostElement = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  private readonly initialDialogHeightPx = 600;

  data: {
    parameterDataList: dsDtos.ParameterData[];
    parameters: dsDtos.Parameter[];
    categories: dsDtos.ParameterCategory[];
    subsystems: dsDtos.Subsystem[];
    idDevice: number;
    deviceName: string;
    deviceTypeParameterConfig: dsDtos.DeviceTypeParameterConfigWithAvailableList[];
  } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ParameterDialogComponent>);

  allOrCustomer = signal<'all' | 'customer'>('customer');
  isFullScreen = signal(false);

  readonly userAccess = computed<dsEnums.UserAccess[]>(() => {
    if (this.allOrCustomer() === 'customer') return ['WRITE_LOCAL', 'WRITE_REMOTE', 'READ_REMOTE'];
    return ['WRITE_LOCAL', 'WRITE_REMOTE', 'READ_LOCAL', 'READ_REMOTE', 'NONE'];
  });
  constructor() {
    this.parameterDataService.init(this.data.parameterDataList);
  }

  ngAfterViewInit() {
    const pane = this.hostElement.closest('.cdk-overlay-pane') as HTMLElement | null;
    if (pane && (pane.style.height === '' || pane.style.height === 'fit-content')) {
      pane.style.height = `${this.initialDialogHeightPx}px`;
    }
  }

  getTitle() {
    return `${this.data.deviceName || 'Device'} ${this.data.idDevice} - Parameter`;
  }

  onChangeAllOrCustomer($event: MatButtonToggleChange) {
    this.allOrCustomer.set($event.value);
  }

  onResized(isFullScreen: boolean) {
    this.isFullScreen.set(isFullScreen);
    if (isFullScreen) {
      this.dialogRef.updateSize('100vw', '100vh');
    } else {
      this.dialogRef.updateSize(DIALOG_WIDE_CONFIG.width, `${this.initialDialogHeightPx}px`);
    }
  }
}
